module.exports = __webpack_public_path__ + "static/image-banner-hunting-f21c506a490a841e2507de7e07548f86.png";